import { useMutation } from 'react-query';

import { deleteProjectWithConstraints as mutationFn } from 'api/endPoints/deleteProjectWithConstraints';

export const useMutationDeleteProject = () => {
    return useMutation<string, QueryError, QueryParams>({
        mutationFn: (params) => mutationFn(params),
    });
};

export interface QueryParams {
    id?: number;
}
